import ErrorService from "services/error.service";
import OneSignalService from "services/onesignal.service";
import SentryService from "services/sentry.service";

const InitializationService = {
	init: () => {
		SentryService.init();
		ErrorService.init();
		OneSignalService.init();
	},
};

export default InitializationService;
